/**
 * 德育评价项目 API
 */
import { request } from './request'

/**
 * 创建评价项目
 * @param {object} data - 项目数据
 */
export function createEvaluationProject(data) {
  return request('/api/evaluation_project', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 获取指定评价项目
 * @param {number|string} projectId - 项目 ID
 */
export function getEvaluationProject(projectId) {
  return request(`/api/evaluation_project/${projectId}`)
}

/**
 * 获取所有评价项目
 */
export function getEvaluationProjects() {
  return request('/api/evaluation_project')
}

/**
 * 获取所有评价项目（学生会角色对接文档接口）
 */
export function getEvaluationProjectList() {
  return request('/api/evaluation_project/list')
}

/**
 * 根据评价类型获取项目
 * @param {number|string} typeId - 类型 ID
 */
export function getEvaluationProjectsByType(typeId) {
  return request(`/api/evaluation_project/type/${typeId}`)
}

/**
 * 获取评价项目权重信息
 */
export function getEvaluationProjectWeights() {
  return request('/api/evaluation_project/weights')
}

/**
 * 更新评价项目
 * @param {number|string} projectId - 项目 ID
 * @param {object} data - 更新数据
 */
export function updateEvaluationProject(projectId, data) {
  return request(`/api/evaluation_project/${projectId}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

/**
 * 删除评价项目
 * @param {number|string} projectId - 项目 ID
 */
export function deleteEvaluationProject(projectId) {
  return request(`/api/evaluation_project/${projectId}`, {
    method: 'DELETE'
  })
}
